import PropTypes from 'prop-types';

export default PropTypes.shape({
  cancelModal: PropTypes.func,
  closeModal: PropTypes.func,
});

/**
 * @typedef {object} ModalFrameworkMethodsPropType
 * @property {() => void} cancelModal
 * @property {(isCancel: boolean) => void} closeModal
 */
